/**
 * Переносит курсор в конец поля ввода
 * @function  helper
 */
export function moveCursorToEnd(input) {
    var _a;
    const end = (_a = input === null || input === void 0 ? void 0 : input.value.length) !== null && _a !== void 0 ? _a : 0;
    input === null || input === void 0 ? void 0 : input.setSelectionRange(end, end);
}
/**
 * Выделяет весь текст в поле ввода
 * @function  helper
 */
export function selectAll(input) {
    input === null || input === void 0 ? void 0 : input.setSelectionRange(0, input === null || input === void 0 ? void 0 : input.value.length);
}
/**
 * Откладывает колбек на следующий цикл EventLoop
 * @function  helper
 */
export function runAfterRerender(callback) {
    setTimeout(callback, 0);
}
/**
 * Проверяет находится ли курсор в начале поля ввода
 * @function  helper
 */
export function isCursorInTheBeginning(input) {
    return (input === null || input === void 0 ? void 0 : input.selectionStart) === 0;
}
/**
 * Проверяет находится ли курсор в конце поля ввода
 * @function  helper
 */
export function isCursorInTheEnd(input) {
    var _a;
    return (input === null || input === void 0 ? void 0 : input.selectionStart) === ((_a = input === null || input === void 0 ? void 0 : input.value) === null || _a === void 0 ? void 0 : _a.length);
}
